import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import Services from './components/Services';
import SocialProof from './components/SocialProof';
import Footer from './components/Footer';
import SEOSchema from './components/SEOSchema';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <SEOSchema />
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/a2fa61b06b87a0c1b7ab810b11b77ac9/500be7c3a1a7b1506d81a8520e3a5b53.png" 
              alt="Physiotherapie Theresa Mühlbacher Logo" 
              className={`w-auto transition-all duration-500 ${isScrolled ? 'h-28' : 'h-40'}`}
            />
          </div>
          <div className="hidden md:flex items-center gap-10">
            <a href="#home" className={`text-base font-medium tracking-wide transition-colors cursor-pointer hover:text-gold-300 ${
              isScrolled ? 'text-olive-900' : 'text-white'
            }`}>
              Home
            </a>
            <a href="#ueber-mich" className={`text-base font-medium tracking-wide transition-colors cursor-pointer hover:text-gold-300 ${
              isScrolled ? 'text-olive-900' : 'text-white'
            }`}>
              Über mich
            </a>
            <a href="#leistungen" className={`text-base font-medium tracking-wide transition-colors cursor-pointer hover:text-gold-300 ${
              isScrolled ? 'text-olive-900' : 'text-white'
            }`}>
              Leistungen
            </a>
            <a href="#bewertungen" className={`text-base font-medium tracking-wide transition-colors cursor-pointer hover:text-gold-300 ${
              isScrolled ? 'text-olive-900' : 'text-white'
            }`}>
              Bewertungen
            </a>
            <a href="#kontakt" className={`text-base font-medium tracking-wide transition-colors cursor-pointer hover:text-gold-300 ${
              isScrolled ? 'text-olive-900' : 'text-white'
            }`}>
              Kontakt
            </a>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <ValueProposition />
      <Services />
      <SocialProof />
      <Footer />
    </div>
  );
}
